import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/lib/auth";
import { logAccessDenied } from "@/lib/access-log";

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user) {
      logAccessDenied({
        route: location.pathname + location.search,
        reason: "unauthenticated",
        resource: "route:protected",
        errorCode: "401",
      });
    }
  }, [loading, user, location.pathname, location.search]);

  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Načítám…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
};
